<template>
    <div class="myskov-login">
        <div class="myskov-login__col">
            <div class="login-fields">
                <h2 v-text="translations.title"></h2>
                <div class="input-fields">
                    <input-field :name="translations.input_firstname" :value="user.firstName" @input="(val) => user.firstName = val" @enter="createUser" class="booking-field"></input-field>
                    <msg-block type="error" v-if="showErrors && isNotValid && isNotValid.firstName">
                        <p v-for="error in isNotValid.firstName"><b v-text="error"></b></p>
                    </msg-block>
                    <input-field :name="translations.input_lastname" :value="user.lastName" @input="(val) => user.lastName = val" @enter="createUser" class="booking-field"></input-field>
                    <msg-block type="error" v-if="showErrors && isNotValid && isNotValid.lastName">
                        <p v-for="error in isNotValid.lastName"><b v-text="error"></b></p>
                    </msg-block>
                    <input-field :name="translations.input_email" :value="user.email" @input="(val) => user.email = val" @enter="createUser" input-type="email" class="booking-field"></input-field>
                    <msg-block type="error" v-if="showErrors && isNotValid && isNotValid.email">
                        <p v-for="error in isNotValid.email"><b v-text="error"></b></p>
                    </msg-block>
                    <input-field :name="translations.input_password" input-type="password" :value="user.password" @input="(val) => user.password = val" @enter="createUser" class="booking-field"></input-field>
                    <msg-block type="error" v-if="showErrors && isNotValid && isNotValid.password">
                        <p v-for="error in isNotValid.password"><b v-text="error"></b></p>
                    </msg-block>
                    <input-field :name="translations.input_password_confirm" input-type="password" :value="passwordConfirm" @input="(val) => passwordConfirm = val" @enter="createUser" class="booking-field"></input-field>
                    <msg-block type="error" v-if="showErrors && isNotValid && isNotValid.passwordConfirm">
                        <p v-for="error in isNotValid.passwordConfirm"><b v-text="error"></b></p>
                    </msg-block>
                </div>
                <button class="btn btn--positive" v-text="translations.create_user_btn" @click="createUser" :class="{'item-loading': loading}" :disabled="loading"></button>
                <msg-block type="error" v-if="createError">
                    <p><b v-text="createError"></b></p>
                </msg-block>
            </div>
        </div>
        <div class="myskov-login__col">
            <div class="login-help">
                <h2 v-text="translations.help_txt_header"></h2>
                <p v-for="text in translations.help_txt" v-html="text"></p>
            </div>
        </div>
    </div>
</template>

<script>
import InputField from '../input-field.vue';
import Validate from 'validate.js';
import MsgBlock from '../msg-block.vue';
import SkovApi from '../../skovapi.js';
import _ from 'underscore';

export default {
    data() {
        return {
            translations: APP_CONFIG.TRANSLATION.NEW_USER,
            showErrors: false,
            createError: null,
            loading: false,
            user: {
                "email": "",
                "password": "",
                "firstName": "",
                "lastName": "",
                "subscribeNewsletter": false
            },
            passwordConfirm: ''
        }
    },
    methods: {
        createUser() {
            this.createError = null;
            if(this.isNotValid) {
                this.showErrors = true;
                return;
            }

            if(this.loading)
                return;

            this.showErrors = false;
            this.loading = true;
            SkovApi.createUser(this.user).then((res) => {
                return this.$store.dispatch('login', this.user).then(() => {
                    if(this.$route.query.navigateBack) {
                        this.$router.back();
                    } else {
                        this.$router.push({
                            path: '/myskov/profile'
                        });
                    }
                }).catch((error) => {
                    console.error(error);
                    this.loading = false;
                    this.createError = this.translations.ERRORS.no_login;
                });
            }).catch((error) => {
                this.loading = false;
                if(error.response && error.response.data && error.response.data.message === 'Email is already in use') {
                    this.createError = this.translations.ERRORS.email_taken;
                } else {
                    console.error(error);
                    this.createError = this.translations.ERRORS.user_not_created;
                }
            })
        }
    },
    computed: {
        isNotValid() {
            let errors = Object.assign({ }, Validate(this.user, {
                firstName: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.firstName  
                    }
                },
                lastName: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.lastName  
                    }
                },
                email: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.email  
                    },
                    email: {
                        message: this.translations.ERRORS.not_valid_email
                    }
                },
                password: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.password
                    },
                    length: {
                        minimum:5,
                        maximum: 128,
                        message: this.translations.ERRORS.password_not_valid
                    }
                }
            }, {
                fullMessages: false
            }));

            if(this.user.password != this.passwordConfirm) {
                errors['passwordConfirm'] = [this.translations.ERRORS.password_confirm]
            }

            return (!_.isEmpty(errors)) ? errors : null;
        }
    },
    components: {
        InputField,
        MsgBlock
    }
}
</script>
